import React from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import AppRoutes from './routing/AppRoutes';

const theme = createMuiTheme({
  palette: { type: 'dark' },
  typography: { subtitle1: { fontSize: 12 }, body1: { fontWeight: 500 } },
});

export default function OptionsApp() {
  return <ThemeProvider theme={theme}><AppRoutes /></ThemeProvider>;
}
